module.exports = __webpack_public_path__ + "img/c9.8f64dcbe.png";